export default "__VITE_ASSET__DX6uk36Q__"